import styled from 'styled-components';

const Recomended = styled.div`
    .Swiper {
       padding-right: 10px;
       padding-bottom: 60px;
    }

    .CardSwiper {
        box-shadow: 10px 10px 12px 0 rgba(30, 30, 60, 0.26);
        img {
            width: 100%;
        }

        h5, h3 {
         text-align: center;
        }
    }

`;

export default Recomended;
